/*
  cstrap-rally.js — 23/09/2026

  Bon cong tac cua ban Rally Builder. File nay CHI duoc nap khi template bat it nhat mot cong tac
  (xem cuoi sections/custom-strap-form.liquid), nen builder 2D dang chay khong tai no va khong doi
  mot dong nao. Moi thu o day chi sua DOM sau khi form da dung xong — khong dung vao cstrap-engine.js
  hay strap-form-preview.js, la hai file dung chung cho ca 300 bai.

  1. khoaDa          — chon san dong da roi giau hai o Skin/Kind. Hai o VAN nam trong DOM (chi
                       display:none) nen gia tri van vao don va hai file engine van doc duoc nhu cu;
                       go han ra la ca hai cho tuong khach chua chon da.
  2. thuTuUnderlay   — dua o Underlay len ngay sau bang mau da.
  3. matchUnderlay   — doi lot thi chi/vien/keeper doi theo, TRU cai khach da tu tay doi.
     08/10 TONG (chu shop) — viet lai theo L1–L11, xem khoi 3 ben duoi. Them khoi 5: ghi chu + popup "?" cua o Underlay
     doi theo kieu rally (Micro / Hybrid / Large). File nap cho MOI builder co o Underlay; khop mau / dua o len van theo setting.
  4. mac dinh        — da Black + lot Cream luc vao bai.
  07/10 dot 1 (chu shop): nap cho MOI builder co o Underlay (DYO / Rally builder / Bespoke).
     - lotSauMau: chi dua o Underlay len ngay sau bang mau da (khong keo Style of Strap — viec do van chi theo thuTuUnderlay).
     - matchUnderlay: chon lot -> Edge colour + Stitch Colour = DUNG MAU THAT cung ten (cong "Custom colour" + o mau), CHI o khach
       chua tu chon; khong co mau cung ten -> giu nguyen, khong lay mau gan nhat. Keeper khong doi. Dong ghi chu duoi o Underlay.
  08/10 (chu shop): chi chay khi template BAT setting (khong tu bat cho moi builder). Luon ghi MAU THAT dung ten (bo duong
     "Match underlay colour" + mau gan nhat). keeperTheoLot (setting rieng, mac dinh TAT): keeper cung doi theo lot — cong
     "One colour" + o mau keeper dung ten; khong co ten do -> keeper giu nguyen. Lot mac dinh KHONG dat khi o Underlay dang an.
*/
(function () {
  'use strict';
  var CH = window.CSTRAP_RALLY;
  if (!CH) return;

  /*
    Ba truong an theo lot. Thu tu uu tien khi dat mau:

    1. Neu o chon che do CO san lua chon "Match underlay colour" thi dung CAI DO — day la co che
       san co cua form, no tu bam theo lot moi lan khach doi, va no dung dung ma mau that cua lot.
       Vien di duong nay moi ra dung Cream: bang mau vien chi co 17 mau va KHONG co Cream.
       Keeper BAT BUOC di duong nay: bang mau keeper la mau DA (keeper cat tu chinh tam da), nen
       tim "Cream" trong do se snap ra mot mau da bat ky — do that 23/09 ra "Charcoal Plum".
    2. Khong co thi mo bang mau rieng roi chon dung ten, khong co ten do thi lay mau gan nhat.
       Chi di duong nay (cong chi chi co "Cream (recommended) / Match leather / Custom colour")
       va bang chi co du Cream nen ra dung.
  */
  var KHOP_LOT = 'Match underlay colour';
  /* 23/09 (chu shop): KEEPER khong nam trong danh sach nay — no giu nguyen "Match leather".
     Keeper cat tu chinh tam da nen de no theo mau da la dung vat lieu; keo no theo lot thi
     vong keeper thanh mot mau khac han than day. Chi con chi va vien di theo lot. */
  var THEO = [
    { ten: 'stitch', gate: '-stitch-colour', mo: 'Custom colour', o: 'Thread Colour' },
    { ten: 'edge',   gate: '-edge-colour',   mo: 'Custom colour', o: 'Custom Edge Colour' }
  ];

  function hex2rgb(h) {
    h = (h || '').replace('#', '');
    if (h.length !== 6) return null;
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  /*
    Ba bang mau KHONG trung nhau: lot va chi co 24 mau, vien chi co 17 va KHONG co Cream
    (son canh la vat lieu khac, xuong khong co lo mau do). Nen "lot Cream -> vien Cream" la
    mot lenh khong thuc hien duoc dung tu. Thay vi bo qua im lang, lay mau GAN NHAT trong chinh
    bang do — Cream se ra White. Hex doc thang tu o mau dang hien (data-hex), khong chep lai
    bang mau sang day: chep la mot ngay nao do hai ban lech nhau ma khong ai biet.
  */
  function chonGanNhat(hop, ten) {
    var os = [].slice.call(hop.querySelectorAll('input[type="radio"]'));
    if (!os.length) return null;
    var dung = os.filter(function (r) { return r.value === ten; })[0];
    if (dung) return dung;
    var goc = null;
    os.forEach(function (r) {
      var l = r.closest('.ccolor');
      if (l && l.getAttribute('title') === ten) goc = l.getAttribute('data-hex');
    });
    if (!goc) {                      /* ten khong co trong chinh bang nay -> tim hex o bang khac */
      var b = document.querySelector('.ccolor[title="' + ten.replace(/"/g, '') + '"][data-hex]');
      goc = b && b.getAttribute('data-hex');
    }
    var g = hex2rgb(goc);
    if (!g) return null;
    var tot = null, min = 1e9;
    os.forEach(function (r) {
      var l = r.closest('.ccolor'), c = hex2rgb(l && l.getAttribute('data-hex'));
      if (!c) return;
      var d = (c[0] - g[0]) * (c[0] - g[0]) + (c[1] - g[1]) * (c[1] - g[1]) + (c[2] - g[2]) * (c[2] - g[2]);
      if (d < min) { min = d; tot = r; }
    });
    return tot;
  }

  function doi(el) { el.dispatchEvent(new Event('change', { bubbles: true })); }

  function chay(sid, cfg) {
    var root = document.getElementById('cstrap-' + sid);
    if (!root) return;
    if (root.__rallyChay) return;      /* L11: chay mot lan cho moi trang (back/forward khong nhan doi listener) */
    root.__rallyChay = 1;
    /* 08/10: keeper chi tu doi khi bat setting rieng (keeper_theo_underlay) */
    var THEO_O = THEO.concat(cfg.keeperTheoLot ? [{ ten: 'keeper', gate: '-keeper-colour', mo: 'One colour', o: 'Custom Keeper Colour' }] : []);

    function o(ten) { return root.querySelector('[name="properties[' + ten + ']"]'); }
    function os(ten) { return [].slice.call(root.querySelectorAll('[name="properties[' + ten + ']"]')); }
    function gate(hau) { return document.getElementById('cf-' + sid + hau); }

    /* ---------- 1. dong da ----------
       24/09 (chu shop): KHONG khoa Epsom nua. Ca hai o Skin/Kind deu o lai va doi duoc —
       bai nay ban rally cua MOI dong da. Chi khac builder thuong o mot diem: vao trang la
       Epsom da duoc chon san, nen bang mau Epsom xo ra ngay, khach thay mau luon thay vi
       nhin mot o trong roi phai doan la minh can bam gi truoc.

       An dong da THIEU layer rally: bai chi ban ba kieu duc lo, dong nao khong du ba kieu
       ma van de trong danh sach thi khach chon xong se thay mot khung trong. Danh sach cho
       phep dat o template (cfg.daChoPhep) chu khong do o day — them dong da moi la sua mot
       dong cai dat, khong phai sua code. */
    (function () {
      var skin = gate('-skin-of-leather'), kind = gate('-kind-of-leather');
      if (!skin || !kind) return;

      var cho = (cfg.daChoPhep || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      function locKind() {
        if (!cho.length) return;
        [].slice.call(kind.options).forEach(function (o) {
          if (!o.value) return;
          var ok = cho.indexOf(o.value) > -1;
          o.hidden = !ok; o.disabled = !ok;
        });
        /* Dang chon mot dong vua bi an (vd doi Skin sang nhom khac) -> tra ve o trong thay vi
           de khach dung o mot lua chon khong ve duoc gi. */
        var dang = [].slice.call(kind.options).filter(function (o) { return o.value === kind.value; })[0];
        if (dang && dang.hidden) { kind.value = ''; doi(kind); }
      }
      skin.addEventListener('change', function () { setTimeout(locKind, 0); });
      kind.addEventListener('change', function () { setTimeout(locKind, 0); });

      /* Chon san dong da mac dinh. Nhom da (Regular/Exotic/Non) tu do ra: thu tung nhom,
         nhom nao lam hien ten da can thi giu — khong bat template khai them mot o nua. */
      if (cfg.daTen) {
        var nhom = [].slice.call(skin.options).map(function (x) { return x.value; }).filter(Boolean);
        for (var i = 0; i < nhom.length; i++) {
          skin.value = nhom[i]; doi(skin);
          if ([].slice.call(kind.options).some(function (x) { return x.value === cfg.daTen; })) break;
        }
        kind.value = cfg.daTen; doi(kind);
      }
      locKind();
    })();

    /* ---------- 2. thu tu truong ----------
       Skin/Kind -> bang mau da -> Underlay -> Style of Strap -> con lai.

       Cap "mau da / mau lot" la thu quyet dinh soi day rally (den tren do, cam tren xanh),
       nen phai dung ngay canh nhau va dung ngay sau o chon da. Style of Strap xuong sau cap
       do: kieu duc lo la lua chon nhe hon, khach doi sau cung duoc. */
    if (cfg.thuTuUnderlay || cfg.lotSauMau) {
      var uf = document.getElementById('cunderlay-field-' + sid);
      var luoi = document.getElementById('cstrap-color-' + sid);
      if (uf && luoi && luoi.parentNode) {
        if (cfg.thuTuUnderlay && !cfg.lotSauMau) uf.style.removeProperty('display');   /* Liquid dat san display:none; tu day de preview quyet. 08/10: builder co preview -> preview quyet hien/an, khong go */
        luoi.parentNode.insertBefore(uf, luoi.nextSibling);
      }
    }
    if (cfg.thuTuUnderlay) {
      /* 24/09 (chu shop): Style of Strap len DAU, truoc ca o chon da. Khach vao bai nay la
         da biet minh muon day rally, viec dau tien can hoi la duc lo kieu nao — chon xong roi
         moi den chuyen da gi, mau gi. (Ban 23/09 dat no sau Underlay; da doi.) */
      var oKieu = root.querySelector('[name="properties[Style of Strap]"]');
      var fKieu = oKieu && oKieu.closest('.cfield');
      var oSkin = gate('-skin-of-leather');
      var fSkin = oSkin && oSkin.closest('.cfield');
      /* Chen truoc CA CUM, khong phai truoc o Skin: Skin va Kind nam chung mot luoi doi
         (.cgrid2--pair). Chen vao giua luoi do thi Style thanh o thu nhat cua cap, nam cung
         hang voi Skin va day Kind xuong mot minh — do 24/09: Style va Skin cung o y=406.
         Neo dung la phan tu cha gan nhat ma van con la con cua form. */
      var neo = fSkin;
      while (neo && neo.parentNode && !neo.parentNode.classList.contains('cstrap__form')) {
        neo = neo.parentNode;
      }
      if (fKieu && neo && neo.parentNode && fKieu !== neo && !neo.contains(fKieu)) {
        neo.parentNode.insertBefore(fKieu, neo);
      }
    }

    /* ---------- 3. vien / chi (/ keeper) di theo lot — 08/10 TONG (chu shop), luat L1–L11 ----------
       L1  Moi o (Edge, Stitch; Keeper khi bat setting) co trang thai TU DONG (mac dinh) / KHACH CHON.
       L2  Doi Underlay -> o TU DONG doi theo: Edge = "Match underlay colour" (co che san cua form, preview ve dung mau lot);
           Stitch = dung ten mau lot trong bang chi. O KHACH CHON giu nguyen.
       L3  Khach tu bam Edge / Stitch (ke ca chon lai dung mau dang co) -> KHACH CHON. Edge chon lai "Match underlay colour"
           -> ve TU DONG.
       L4  Su kien file nay tu ban (co noi bo dangTu) KHONG tinh la khach chon — khong so sanh gia tri. Chi tinh thao tac that
           (isTrusted) de su kien engine tu ban cung khong bi tinh nham.
       L5  Keeper khong tu doi (tru khi bat keeper_theo_underlay).
       L6  Doi da / mau da -> khong dung toi Edge / Stitch (file nay khong nghe hai o do).
       L7  Kieu khong lo -> o Underlay an, o TU DONG ve mac dinh (gia tri luc vao trang), o KHACH CHON giu; quay lai rally -> ap lai L2.
       L8  Lot khong co mau chi cung ten -> Stitch giu nguyen (bang chi khong co phu phi theo mau). Ghi vao CSTRAP_KHOP[sid].khongKhop.
       L9  Dong duoi o Underlay (gop voi ghi chu kieu rally, khoi 5); an khi moi o deu KHACH CHON.
       L10 Gio / tom tat ghi MAU THAT — engine (gonProps) doi "Match underlay colour" thanh ten mau lot.
       L11 Chay mot lan (co root.__rallyChay). */
    var dangTu = 0;
    function doiNoi(el) { dangTu++; try { el.dispatchEvent(new Event('change', { bubbles: true })); } finally { dangTu--; } }
    var CHE = {}, khongKhop = {};
    THEO_O.forEach(function (m) { CHE[m.ten] = 'tu'; });
    window.CSTRAP_KHOP = window.CSTRAP_KHOP || {};
    window.CSTRAP_KHOP[sid] = { che: CHE, khongKhop: khongKhop };
    /* gia tri cong luc vao trang = "mac dinh" cho L7 */
    var GOC = {};
    THEO_O.forEach(function (m) { var g = gate(m.gate); GOC[m.ten] = g ? g.value : null; });

    function ufEl() { return document.getElementById('cunderlay-field-' + sid); }
    /* 11/10 LAG B2/R1: bo getClientRects + getComputedStyle (ep dan trang moi lan goi). O Underlay do strap-form-preview.js an/hien bang style.display + hidden -> chi can duyet tu o len. */
    function lotHien() { var u = ufEl(); if (!u) return false; for (var n = u; n && n !== document.body; n = n.parentElement) { if (n.hidden || n.style.display === 'none') return false; } return true; }
    function lotDangChon() {
      var r = os('Underlay Colour').filter(function (x) { return x.checked && !x.disabled; })[0]
           || os('Custom Underlay Colour').filter(function (x) { return x.checked && !x.disabled; })[0];
      return r ? r.value : '';
    }
    function coOp(g, v) { return !!g && [].some.call(g.options, function (x) { return x.value === v; }); }
    function datCong(g, v) { if (!g || !coOp(g, v)) return false; if (g.value !== v) { g.value = v; doiNoi(g); } return true; }
    function chonMau(ten, gt) {
      var r = os(ten).filter(function (x) { return x.value === gt && !x.disabled; })[0];
      if (!r) return false;
      if (!r.checked) { r.checked = true; doiNoi(r); }
      return true;
    }
    /* cong "Custom colour" / "One colour" + o mau DUNG TEN; khong co ten do -> tra cong ve nhu truoc (L8) */
    function datTheoTen(m, ten) {
      var g = gate(m.gate);
      if (!g || !coOp(g, m.mo)) return;
      var truoc = g.value;
      datCong(g, m.mo);
      setTimeout(function () {   /* bang mau nam trong <template>, engine clone ra sau khi cong mo */
        if (CHE[m.ten] !== 'tu') return;
        if (chonMau(m.o, ten)) { delete khongKhop[m.ten]; }
        else { khongKhop[m.ten] = ten; if (truoc !== m.mo) datCong(g, truoc); }
        veGhiChu();
      }, 60);
    }
    function apDung() {
      if (!cfg.matchUnderlay || !lotHien()) return;
      var ten = lotDangChon();
      if (!ten) return;
      THEO_O.forEach(function (m) {
        if (CHE[m.ten] !== 'tu') return;
        if (m.ten === 'stitch') { var gS = gate(m.gate); if (gS) ghiChiThat(gS, ten); }   /* 08/10 12:35: mau chi THAT cho preview + gio */
        if ((m.ten === 'edge' || m.ten === 'stitch') && datCong(gate(m.gate), KHOP_LOT)) return;   /* L2 (12:35): Edge + Stitch = Match underlay colour */
        datTheoTen(m, ten);                                                  /* Keeper (setting) = dung ten; form khong co "Match underlay colour" */
      });
      veGhiChu();
    }
    /* 08/10 12:35 (chu shop): mau LOT la mau chinh cua day rally. Vao kieu rally ma khach CHUA tu chon lot -> lot Cream (full kem).
       Quay lai tu Classic: lot khach da chon truoc do giu nguyen. */
    var lotKhach = false, lotKhachMau = '';   /* lot KHACH da chon — quay lai tu Classic thi dat lai dung mau nay */
    /* 12/10 (chu shop, viec 2): LINK (nut but "Customize this strap": ?stitch= ?edge= ?keeper= ?hole=) duoc ap SAU mac dinh Rally.
       O nao link CO gia tri -> coi la KHACH CHON (Rally khong de len Match underlay); lot trong link -> lot khach. Link khong co -> mac dinh nhu cu.
       Link ghi chinh "Match underlay colour" thi o van o che do TU (theo lot). */
    (function () {
      var lq = new URLSearchParams(location.search), lay = function (k) { return (lq.get(k) || '').trim(); };
      var dl = { stitch: lay('stitch'), edge: lay('edge'), keeper: lay('keeper') };
      THEO_O.forEach(function (m) { if (dl[m.ten] && dl[m.ten] !== KHOP_LOT) CHE[m.ten] = 'khach'; });
      var hl = lay('hole') || lay('underlay');
      if (hl) { lotKhach = true; lotKhachMau = hl; }
    })();
    function datLotMacDinh() {
      if (!cfg.matchUnderlay || !lotHien()) return;
      var md = lotKhach ? lotKhachMau : (cfg.lotMacDinh || 'Cream');
      if (!md) return;
      var r = os('Underlay Colour').filter(function (x) { return x.value === md && !x.disabled; })[0];
      if (r && !r.checked) { r.checked = true; doiNoi(r); }
    }
    /* Lua chon "Match underlay colour" cua o chi: CHI hien o kieu rally (o Underlay dang hien). Ve Classic -> an + tra o chi ve mac dinh. */
    function anHienMucChi() {
      var g = gate('-stitch-colour');
      if (!g) return;
      var co = lotHien();
      [].forEach.call(g.options, function (o) { if (o.value === KHOP_LOT) { o.hidden = !co; o.disabled = !co; } });
      if (!co && g.value === KHOP_LOT && GOC.stitch != null && GOC.stitch !== KHOP_LOT) datCong(g, GOC.stitch);
    }
    /* Mau chi THAT cho lot: dung ten trong bang chi; bang chi khong co ten do -> mau chi GAN NHAT (CIELAB) — tam thoi, chu shop chua
       chot cach xu ly. Ghi vao data-chi-that cua o chi: preview (strap-form-preview.js) va gio (gonProps) cung doc mot cho. */
    function hexLot(ten) {
      var l = document.querySelector('[id^="cunderlay-field-"] .ccolor[title="' + String(ten).replace(/"/g, '') + '"]');
      return l ? l.getAttribute('data-hex') : '';
    }
    function bangChi() {
      var ds = [], tp = document.querySelector('[id^="cstitch-custom-"] template');
      var goc = tp ? tp.content : document.querySelector('[id^="cstitch-custom-"]');
      if (!goc) return ds;
      [].forEach.call(goc.querySelectorAll('.ccolor[data-hex]'), function (l) { var i = l.querySelector('input'); if (i) ds.push({ ten: i.value, hex: l.getAttribute('data-hex') }); });
      if (!ds.length) [].forEach.call(document.querySelectorAll('[id^="cstitch-custom-"] .ccolor[data-hex]'), function (l) { var i = l.querySelector('input'); if (i) ds.push({ ten: i.value, hex: l.getAttribute('data-hex') }); });
      return ds;
    }
    function lab(hex) {
      var c = hex2rgb(hex); if (!c) return null;
      var v = c.map(function (x) { x /= 255; return x > 0.04045 ? Math.pow((x + 0.055) / 1.055, 2.4) : x / 12.92; });
      var X = (v[0] * 0.4124 + v[1] * 0.3576 + v[2] * 0.1805) / 0.95047, Y = v[0] * 0.2126 + v[1] * 0.7152 + v[2] * 0.0722, Z = (v[0] * 0.0193 + v[1] * 0.1192 + v[2] * 0.9505) / 1.08883;
      var f = function (t) { return t > 0.008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116; };
      X = f(X); Y = f(Y); Z = f(Z); return [116 * Y - 16, 500 * (X - Y), 200 * (Y - Z)];
    }
    function chiChoLot(ten) {
      var ds = bangChi();
      if (ds.some(function (x) { return x.ten === ten; })) return ten;
      var w = lab(hexLot(ten)); if (!w) return '';
      var tot = '', min = 1e9;
      ds.forEach(function (x) { var c = lab(x.hex); if (!c) return; var d = Math.pow(w[0] - c[0], 2) + Math.pow(w[1] - c[1], 2) + Math.pow(w[2] - c[2], 2); if (d < min) { min = d; tot = x.ten; } });
      if (tot) khongKhop.stitch = ten + ' -> ' + tot;
      return tot;
    }
    function ghiChiThat(g, ten) {
      var moi = chiChoLot(ten) || '';
      if (g.dataset.chiThat !== moi) { g.dataset.chiThat = moi; g.dataset.chiLot = ten; if (g.value === KHOP_LOT) doiNoi(g); }   /* doiNoi: preview ve lai chi */
    }
    function traVeMacDinh() {   /* L7 */
      THEO_O.forEach(function (m) { if (CHE[m.ten] === 'tu' && GOC[m.ten] != null) datCong(gate(m.gate), GOC[m.ten]); });
      veGhiChu();
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      var n = (/^properties\[(.*)\]$/.exec(t.name || '') || [])[1] || '';
      if (n === 'Underlay Colour' || n === 'Custom Underlay Colour') { if (!dangTu && e.isTrusted) { lotKhach = true; lotKhachMau = t.value; } setTimeout(apDung, 0); }
      if (n === 'Style of Strap') { setTimeout(function () { veKieu(); anHienMucChi(); if (lotHien()) { datLotMacDinh(); apDung(); } else traVeMacDinh(); }, 350); }
      if (dangTu || !e.isTrusted) return;   /* L4 */
      var id = t.id || '';
      THEO_O.forEach(function (m) {
        if (n !== m.o && id.indexOf(sid + m.gate) < 0) return;
        /* L3: Edge chon lai "Match underlay colour" -> ve tu dong; con lai -> khach chon */
        CHE[m.ten] = ((m.ten === 'edge' || m.ten === 'stitch') && id.indexOf(sid + m.gate) > -1 && t.value === KHOP_LOT) ? 'tu' : 'khach';
        if (CHE[m.ten] === 'tu') apDung();
      });
      veGhiChu();
    });

    /* ---------- 5. o Underlay theo kieu rally (08/10 TONG, chu shop) ----------
       Ghi chu duoi nhan + popup "?" doi theo kieu: Micro / Hybrid / Rally (Large Holes). Anh popup: setting rieng tung kieu,
       trong -> anh chung underlay-guide.webp. Dong L9 gop vao CUNG doan ghi chu. */
    var KIEU = {
      micro:  { ten: 'Micro Rally', note: 'Seen through the small holes of your Micro Rally — a subtle touch of colour.',
                pop: 'Your Micro Rally has small holes, so the underlay reads as fine dots of colour — pick a strong contrast if you want it noticed.' },
      hybrid: { ten: 'Hybrid Rally', note: 'Seen through the holes of your Hybrid Rally — large and small together.',
                pop: 'Your Hybrid Rally mixes large and small holes, so the underlay shows as both bold spots and fine dots.' },
      large:  { ten: 'Rally (Large Holes)', note: 'Seen through the large holes of your Rally — a bold contrast.',
                pop: 'Your Rally has large holes, so the underlay is a big part of the look — a contrast stands out, a close shade stays quiet.' }
    };
    var CHUNG = 'A rally strap is two layers of leather. The top layer is punched with holes; the underlay sits beneath it and shows through every hole.';
    function kieuDangChon() {
      var r = os('Style of Strap').filter(function (x) { return x.checked; })[0];
      var v = r ? r.value : '';
      return /micro/i.test(v) ? 'micro' : /hybrid/i.test(v) ? 'hybrid' : /large|^rally/i.test(v) ? 'large' : '';
    }
    function veGhiChu() {
      var uf = ufEl(), f = uf && uf.querySelector('.cfield');
      if (!f) return;
      var p = f.querySelector('.ckieu-note');
      if (!p) {
        p = document.createElement('p');
        p.className = 'cdesc ckieu-note';
        var nhan = f.querySelector('.cfield__labelrow, .cfield__label');
        if (nhan) nhan.insertAdjacentElement('afterend', p); else f.insertBefore(p, f.firstChild);
      }
      var k = KIEU[kieuDangChon()];
      var khop = cfg.matchUnderlay && THEO_O.some(function (m) { return CHE[m.ten] === 'tu'; });
      var chu = (k ? k.note : '') + (khop ? (k ? ' ' : '') + (cfg.keeperTheoLot ? 'Edge, stitching & keepers' : 'Edge & stitching') + ' match your underlay — change them anytime below.' : '');
      p.textContent = chu;
      p.hidden = !chu;
      /* nhan "UNDERLAY COLOUR: <mau>" luon theo o DANG chon (engine co the tu chon lai mau ma khong ban su kien) */
      var h = f.querySelector('.hint'), lot = lotDangChon();
      if (h && h.textContent !== lot) { h.textContent = lot; h.classList.toggle('is-picked', !!lot); }
    }
    function veKieu() {
      var uf = ufEl(), nut = uf && uf.querySelector('.chelp');
      var key = kieuDangChon(), k = KIEU[key];
      if (nut && k) {
        nut.setAttribute('data-help-title', 'Underlay colour — ' + k.ten);
        nut.setAttribute('data-help-text', CHUNG + ' ' + k.pop + (cfg.matchUnderlay ? ' Edge and stitching follow the underlay unless you change them.' : ''));
        var anh = (cfg.anhLot && (cfg.anhLot[key] || cfg.anhLot.chung)) || '';
        if (anh) nut.setAttribute('data-help-img', anh);
      }
      veGhiChu();
    }
    veKieu();
    setTimeout(veKieu, 800);   /* engine dung xong o / chon kieu mac dinh */

    /* ---------- 4. luc vao trang (08/10 12:35): an/hien lua chon "Match underlay colour" cua o chi; kieu rally -> lot Cream + khop ---------- */
    var lan = 0;
    (function dat() {
      lan++;
      anHienMucChi();
      if (!lotHien()) { if (lan < 20) setTimeout(dat, 250); return; }
      datLotMacDinh();
      apDung();
    })();
  }

  function batDau() { Object.keys(CH).forEach(function (sid) { chay(sid, CH[sid]); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', batDau);
  else batDau();
})();
